import React from 'react';
import './Footer.css';

type NavigationItem = 'about' | 'programs' | 'social' | 'listen';

interface FooterProps {
  onNavigate?: (item: NavigationItem) => void;
}

const Footer: React.FC<FooterProps> = React.memo(({ onNavigate }) => {
  const navigationItems: Array<{ id: NavigationItem; label: string }> = [
    { id: 'about', label: 'О проекте' },
    { id: 'programs', label: 'Программы' },
    { id: 'social', label: 'Мы в социальных сетях' },
    { id: 'listen', label: 'Где можно слушать?' }
  ];

  const handleNavigationClick = (item: NavigationItem) => {
    if (onNavigate) {
      onNavigate(item);
    }
  };

  return (
    <div className="footer">
      <div className="footer-content">
        <nav className="footer-navigation" aria-label="Навигация по сайту">
          {navigationItems.map((item) => (
            <button
              key={item.id}
              className="footer-nav-button"
              onClick={() => handleNavigationClick(item.id)}
              aria-label={item.label}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
});

Footer.displayName = 'Footer';

export default Footer;
